// Eligibility is calculated by the driver. Older drivers fail closed until upgraded.
export function driverCheapestSelection(comparison) {
  const decision = comparison?.cheapest;
  const unavailableSuppliers = decision?.unavailableSuppliers || [];
  if (!decision) return { message:'Update the shop driver to calculate the cheapest comparable offer.', unavailableSuppliers };
  const result = decision.supplier && comparison.suppliers?.find(item => item.supplier === decision.supplier && item.status === 'ok' && item.product);
  return result ? { result, unavailableSuppliers } : { message:decision.reason || 'No cheapest comparable offer is available.', unavailableSuppliers };
}
